import {apiClient} from '@/core/apiClient';

export type AdoptionWaitRequest = {
  id: number;
  speciesId: number;
  sexId?: number | null;
  sizeId?: number | null;
  breedId?: number | null;
  minAgeMonths?: number | null;
  maxAgeMonths?: number | null;
  status: 'active' | 'deleted';
  createdAt?: string;
  lastFollowupSentAt?: string | null;
  species?: any;
  sex?: any;
  size?: any;
  breed?: any;
  adopterCity?: string | null;
  adopterName?: string | null;
  adopterPhone?: string | null;
};

export type AdoptionWaitPayload = {
  speciesId: number;
  sexId?: number | null;
  sizeId?: number | null;
  breedId?: number | null;
  minAgeMonths?: number | null;
  maxAgeMonths?: number | null;
};

export const adoptionWaitApi = {
  getMine: async (): Promise<AdoptionWaitRequest | null> => {
    const res = await apiClient.get('/me/adoption-wait-request');
    return res.data || null;
  },
  createMine: async (payload: AdoptionWaitPayload): Promise<AdoptionWaitRequest> => {
    const res = await apiClient.post('/me/adoption-wait-request', payload);
    return res.data;
  },
  updateMine: async (id: number, payload: Partial<AdoptionWaitPayload>): Promise<AdoptionWaitRequest> => {
    const res = await apiClient.patch(`/me/adoption-wait-request/${id}`, payload);
    return res.data;
  },
  deleteMine: async (id: number, payload: {reasonCode: string; reasonText?: string | null}) => {
    await apiClient.delete(`/me/adoption-wait-request/${id}`, {data: payload});
  },
  listActive: async (params?: Partial<AdoptionWaitPayload>): Promise<AdoptionWaitRequest[]> => {
    const res = await apiClient.get('/adoption-wait-requests', {params});
    return res.data;
  },
};
